<script setup>
import { BButton, BCard, BCol, BRow, BCardImg } from 'bootstrap-vue-next';

defineProps({
  logoPath: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    required: true,
  },
  actionName: {
    type: String,
    required: true,
  },
  actionLink: {
    type: String,
    default: null,
  },
  to: {
    type: [String, Object],
    default: null,
  },
  buttonVariant: {
    type: String,
    default: 'outline-primary',
  },
  targetBlank: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['action-click']);
</script>

<template>
  <BCard
    class="overflow-hidden h-100"
    :title="title"
  >
    <BRow
      class="g-0"
      align-h="between"
    >
      <BCol
        sm="12"
        md
      >
        <slot />
      </BCol>
      <BCol
        md="auto"
        class="p-3 d-none d-md-block text-end"
      >
        <BCardImg
          v-if="logoPath"
          :src="logoPath"
          class="rounded-0"
          width="75"
          height="75"
          placement="end"
        />
      </BCol>
    </BRow>
    <template #footer>
      <BButton
        :variant="buttonVariant"
        :to="to"
        :href="actionLink"
        :target="to === null && targetBlank ? '_blank' : null"
        @click="emit('action-click')"
      >
        {{ actionName }}
      </BButton>
    </template>
  </BCard>
</template>
